/* eslint-disable consistent-return */

const USER_TENANT = 'tenant';

export const CustomDimensionsManager = instance => ({
  setCustomDimensions(cd) {
    try {
      instance.setCustomDimension(cd);
      if (cd.pageLanguage) {
        instance.set({ locale: cd.pageLanguage });
      }
    } catch (err) {
      console.error('Failed to call setCustomDimensions', { err });
    }
  },
  setCommonCustomDimensions({ userId, locale, pageType }) {
    try {
      const customDimensions = {
        userType: USER_TENANT,
        userRegistered: (!!userId).toString(),
        pageType,
        pageLanguage: locale
      };
      if (userId) {
        customDimensions.userid = userId;
      }

      this.setCustomDimensions(customDimensions);
    } catch (err) {
      console.error('Failed to set custom dimensions', { err });
    }
  },

  sendEvent(...args) {
    instance.sendEvent(...args);
  }
});

export default {
  CustomDimensionsManager
};
